import { environment } from 'libs/environment';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl, UntypedFormControl, Validators } from '@angular/forms';
import { Subscription, from, of, timer } from 'rxjs';
import { map, catchError, flatMap, mergeAll, distinct, filter, toArray } from 'rxjs/operators';
import { intersection } from 'libs/helpers/lodash-helper';


import { IAdditionalParams } from '../../../shared/models';
import { CommonMessageText, ValidatorSetting } from '../../../shared/constant';
import { IUserSettingModel } from '../../../application/models';
import { ConfirmDialogService, ErrorMessageModel } from 'libs/ui';
import { CollectionModel } from '../models';
import { PersonalCollectionService } from '../services';
import { ERROR_TYPE, ERROR_MESSAGE, DATE_TIME_CALL_STANDARD } from 'libs/constants';
import { CustomValidators } from '../../../shared/validators';
import { CollectionService, IfactService, UserSettingService, SessionService, RoleService, ApplicationStateService } from 'libs/shared/services';
import { validationProjectedDate } from 'libs/helpers/job-helper';
import { AutoUnsubscribe } from 'libs/helpers/subscription-helper';
import { MessageService } from 'primeng/api';
import { LazyLoadEvent } from 'primeng/api';
import { ChangeJobOwnerDialogComponent } from '../../../shared/components/change-job-owner-dialog/change-job-owner-dialog.component';
import { JobForm } from '../../../shared/models/job-form';
import { WellGroupValidatorService } from '../../../well/services/well-group-validation.service';

@AutoUnsubscribe()
@Component({
    selector: 'collection-management',
    templateUrl: './collection-management.component.html',
    styleUrls: ['./collection-management.component.scss'],
    providers: [PersonalCollectionService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class CollectionManagementComponent implements OnInit, OnDestroy {

  @ViewChild(ChangeJobOwnerDialogComponent) changeJobOwnerDialogComponent: ChangeJobOwnerDialogComponent;
  @ViewChild('divClick', { static: true }) divClick: ElementRef;
  readonly DATE_TIME_CALL_STANDARD: string = DATE_TIME_CALL_STANDARD;
  collectionId: string;
  jobs: JobForm[];
  userSettings: IUserSettingModel;
  totalRecords: number = null;
  firstPage: number = 0;
  rowsPerPage: number = 200;
  sortField: string = 'modifiedDate';
  sortOrder: number = -1;
  opsMessageText: string;
  additionalParams: IAdditionalParams;
  isShowRenameCollection: boolean = false;
  navLinkCol = '/collections';
  loadingSubscription: Subscription;

  collectionNameManagement: any;
  addToCollectionManagementModel: CollectionModel;

  removeCollectionNameManagement: any;
  removeFromCollectionManagementModel: CollectionModel;

  private opsMessageTimer$ = timer(0, environment.opsMessageReloadIntervalInMilisecond);

  collectionName: string;
  renameCollectionModel: CollectionModel;
  collectionEdit: UntypedFormGroup;
  linkMail: string;
  collectionShare: string;
  messageError: string;
  errorMessages = {
    collectionName: [
      new ErrorMessageModel(ERROR_TYPE.REQUIRED, ERROR_MESSAGE.REQUIRED('Collection Name')),
      new ErrorMessageModel(ERROR_TYPE.MaxLength, ValidatorSetting.ERROR_MAX_LENGHT_100_TEXT),
      new ErrorMessageModel(ERROR_TYPE.UNIQUE, ValidatorSetting.ERROR_UNIQUE_COLLECTION_NAME),
    ]
  };

  isDisable: boolean;
  collections = [];
  event: any;
  private wellGroupValidationSub: Subscription;

  cols = [
    { field: 'jobCode', header: 'Job Number', width: '5.76%'},
    { field: 'riskLevel', header: 'Risk', width: '3%' },
    { field: 'customerName', header: 'Customer', width: '12.89%'},
    { field: 'wellName', header: 'Well Name', width: '12.16%'},
    { field: 'wellNumber', header: 'Well Number', width: '5%'},
    { field: 'rigName', header: 'Rig', width: '8.11%'},
    { field: 'jobName', header: 'Job Name', width: '16.68%'},
    { field: 'jobTypeName', header: 'Job Type', width: '8.11%'},
    { field: '', header: 'Control Point', width: '8%'},
    { field: 'jobStatusDescription', header: 'Job State', width: '6.76%'},
    { field: 'actualDate|projectedDate', header: 'Job Date', width: '11%'},
    { field: 'appianPushState', header: 'Sent to Bulk Plant', width: '6%' },
    { field: 'appianBBLoadStatus', header: 'Load Status', width: '6%' },
    { field: 'modifiedDate', header: 'Last Modified', width: '7.77%'}
  ];

  constructor(
    private activatedRoute: ActivatedRoute,
    private userSettingService: UserSettingService,
    private collectionService: CollectionService,
    private ifactService: IfactService,
    private router: Router,
    private confirmDialogService: ConfirmDialogService,
    private messageService: MessageService,
    private personalCollectionService: PersonalCollectionService,
    private fb: UntypedFormBuilder,
    private sessionService: SessionService,
    private ref: ChangeDetectorRef,
    private roleService: RoleService,
    private applicationStateService: ApplicationStateService,
     private wellGroupValidatorService: WellGroupValidatorService
  ) {
    this.userSettings = this.userSettingService.userSettings;
  }

  ngOnInit() {
    this.activatedRoute.queryParamMap.subscribe(value => {
      this.collectionId = value.get('id');
      this.collectionShare = value.get('action');
      this.collectionEdit = this.fb.group({
        collectionName: [this.collectionName, Validators.compose([CustomValidators.requiredWithTrimming, Validators.maxLength(ValidatorSetting.MAX_LENGTH_TEXT_100)]), checkReNameValidator(this.personalCollectionService, this.collectionId)]
      });

      if (this.collectionShare === 'shared') {
        this.collectionEdit.controls['collectionName'].valueChanges.subscribe(() => {
          const objCheckNameShared = {
            id: this.collectionService.collectionIdOld,
            name: this.collectionEdit.controls['collectionName'].value.trim()
          };

          this.personalCollectionService.checkNameSharedCollection(objCheckNameShared).subscribe(res => {
            if (!res) {
              this.messageError = ValidatorSetting.ERROR_UNIQUE_COLLECTION_NAME;
              this.collectionEdit.controls['collectionName'].setErrors({ 'invalid': true });
              // auto click when show messageError
              this.divClick.nativeElement.click();
              this.isDisable = true;
            } else {
              this.messageError = '';
              this.isDisable = false;
            }
          });
        });
      }

      // Redirect when click a link collection share the same name
      if (this.collectionShare === 'share') {
        this.collectionName = '';
        const shareModel = {
          id: this.collectionId,
        };

        this.personalCollectionService.shareCollection(shareModel).subscribe(res => {
          if (res.action === 'Rename') {
            this.messageError = ValidatorSetting.ERROR_UNIQUE_COLLECTION_NAME;
            this.isShowRenameCollection = true;
            this.collectionService.collectionIdOld = this.collectionId;
            this.router.navigate([this.navLinkCol], { queryParams: { id: res.collectionIdOldForRename, action: 'shared' } });
          }
          if (res.action === 'AddNew') {
            this.router.navigate([this.navLinkCol], { queryParams: { id: res.collectionIdNew, action: 'create-shared' } });
            this.collectionService.saveCollectionSuccess$.next(true);
            this.messageService.add({ life: environment.messagePopupLifetimeMs, severity: 'success', summary: '', detail: 'Collection has been created successfully.' });
          }
          if (res.action === 'Owner') {
            this.router.navigate([this.navLinkCol], { queryParams: { id: res.collectionIdOld, action: 'owner-shared' } });
          }

          if (res.action === 'Failure') {
            this.router.navigate(['/active-jobs']);
            this.messageService.add({ life: environment.messagePopupLifetimeMs, severity: 'error', summary: '', detail: 'Your collection does not exist. Please check it again.' });
          }

        });
      } else {
        this.refreshCollection();
      }
    });

    this.opsMessageText = CommonMessageText.TOOLTIPS.OPS_MESSAGE;

    this.event = {
      first: this.firstPage
    };

    this.refreshCollection();
  }

  ngOnDestroy(): void {
    if (this.jobs) {
      this.jobs.forEach(jf => jf.onDestroy());
    }
    if (this.wellGroupValidationSub) {
      this.wellGroupValidationSub.unsubscribe();
    }
  }

  openEmailApplication(event) {
    event.preventDefault();
    const emailSubject = encodeURIComponent(`VIDA: COLLECTION  -  ${this.sessionService.user.userName} has shared collection "${this.collectionName}" with you`);
    const emailBody = encodeURIComponent(this.generateEmailBody(this.collectionId, this.collectionName));

    window.location.href = `mailto:?subject=${emailSubject}&body=${emailBody}`;
  }
  private generateEmailBody(collectionId: string, collectionName: string) {
    const linkToJob = `${window.location.origin}/collections?id=${collectionId}&action=share`;
    const lineBreaker = '_____________________________________________________________________________________________________';

    const body = `


      ${this.sessionService.user.userName} has shared the collection "${collectionName}" with you.
      Click this link ${linkToJob} to add Collection "${collectionName}" to followed Collections.
      ${lineBreaker}
      *Note: Changes made after accepting this collection by the sender will not be reflected in a followed collection.
      ${lineBreaker}
      Access VIDA news, documentation and training material ${environment.sharePointVIDAUrl}
    `;

    return body;
  }

  getJobsByCollection(additionalParams: IAdditionalParams) {
    this.collectionService.getJobsByCollection(this.collectionId, additionalParams)
      .pipe(
        map(response => validationProjectedDate(response))
      )
      .subscribe(response => {
        this.ref.markForCheck();
        this.jobs = response.data.map(item => new JobForm({ ...item, hasNewMessage: false }, this.roleService));

        this.totalRecords = response.totalRecord;

        this.opsMessageTimer$.subscribe(() => this.onLoadMessage(this.jobs));
      });
  }

  onLoadMessage(jobs: JobForm[]) {
    from(jobs).pipe(
      flatMap((jobForm: JobForm) => of(jobForm.job.listRequestByJob)),
      mergeAll(),
      distinct(),
      filter(requestId => !!requestId),
      toArray(),
      flatMap((requestIds: number[]) => this.ifactService.checkOpsMessage(requestIds, true))
    ).subscribe((requestsHaveMessage: number[]) => {
      this.jobs.forEach(e => e.job.hasNewMessage = intersection(e.job.listRequestByJob, requestsHaveMessage).length > 0);
      this.ref.markForCheck();
    });
  }

  // Event for Lazy load of PrimeNG Datatable

  loadMoreJobs(event: LazyLoadEvent) {
    const { sortField, sortOrder, first } = event;
    this.additionalParams = {
      sortField,
      sortOrder: sortOrder === 1 ? 'asc' : 'desc',
      pageSize: this.rowsPerPage,
      pageNum: first / this.rowsPerPage,
    };
    this.getJobsByCollection(this.additionalParams);
  }

  onSortField(sortField: string) {
    if (sortField === this.sortField) {
      this.sortOrder = -this.sortOrder;
    }
  }

  getPage(event) {
    const { first, sortField, sortOrder } = event;

    this.additionalParams = {
      sortField: sortField,
      sortOrder: sortOrder === 1 ? 'asc' : 'desc',
      pageSize: this.rowsPerPage,
      pageNum: first / this.rowsPerPage,
    };
    this.event = { first };
    this.sortField = sortField;
    this.getJobsByCollection(this.additionalParams);
  }

  showRenameCollection() {
    this.isShowRenameCollection = true;
    this.isDisable = false;
  }

  renameCollection() {
    this.renameCollectionModel = {
      id: this.collectionId,
      name: this.collectionEdit.controls['collectionName'].value,
      description: '',
      jobId: '',
      mode: this.collectionShare === 'shared' ? 'Rename' : '',
      CollectionIdOld: this.collectionService.collectionIdOld
    };
    if (this.collectionEdit.valid) {

      if (this.collectionShare === 'shared') {
        this.personalCollectionService.createCollection(this.renameCollectionModel).pipe(
          catchError((response: any) => of(response.error.text))
        ).subscribe(collectionId => {
          this.isShowRenameCollection = false;
          this.messageService.add({ life: environment.messagePopupLifetimeMs, severity: 'success', summary: '', detail: 'Collection name is created successfully.' });
          this.router.navigate([this.navLinkCol], { queryParams: { id: collectionId } });
          this.collectionName = this.renameCollectionModel.name;
          this.refreshCollection();
          this.collectionService.saveCollectionSuccess$.next(true);
        });
      } else {
        this.personalCollectionService.renameCollection(this.renameCollectionModel).subscribe(() => {
          this.isShowRenameCollection = false;
          this.messageService.add({ life: environment.messagePopupLifetimeMs, severity: 'success', summary: '', detail: `Collection  <strong>${this.renameCollectionModel.name}</strong> has been renamed successfully.` });
          this.collectionName = this.renameCollectionModel.name;
          this.refreshCollection();
          this.collectionService.saveCollectionSuccess$.next(true);
        });
      }

    } else {
      this.validateAllFormFields(this.collectionEdit);
    }
  }


  refreshCollection() {
    this.collectionService.refreshCollection$.next(null);
    this.loadingSubscription = this.collectionService.getAllCollections().subscribe((data) => {
      this.ref.markForCheck();
      this.collections = data;
      const currentCollection = this.collections.find(x => x.id === this.collectionId);
      this.collectionName = currentCollection ? currentCollection.name : '';

      this.additionalParams = {
        sortField: this.sortField,
        sortOrder: this.sortOrder === 1 ? 'asc' : 'desc',
        pageSize: this.rowsPerPage,
        pageNum: 0,
      };
      this.getJobsByCollection(this.additionalParams);
    });
    this.ref.markForCheck();
  }

  showDeleteCollection() {
    const name = this.collections.find(x => x.id === this.collectionId).name;
    this.confirmDialogService.show({
      message: `Are you sure to delete collection: <strong>${name}</strong>?`,
      header: 'Message',
      accept: () => {
        this.deleteCollection(this.collectionId, name);
      },
      reject: () => {

      }
    });
  }

  deleteCollection(collectionId: string, collectionName: string) {
    this.personalCollectionService.deleteCollection(collectionId).subscribe(() => {
      this.messageService.add({ life: environment.messagePopupLifetimeMs, severity: 'success', summary: '', detail: `Collection <strong>${collectionName}</strong> has been deleted successfully.` });
      this.router.navigate(['/active-jobs']);
      this.refreshCollection();
    });
  }

  showAllCollectionNameManagement(jobId) {
    // Add to Collection
    this.collectionService.getAllCollectionName(jobId).subscribe(data => {
      this.ref.markForCheck();
      this.collectionNameManagement = data;
    });

    // Remove from Collection
    this.collectionService.getAllCollectionNameRemove(jobId).subscribe(res => {
      this.ref.markForCheck();
      this.removeCollectionNameManagement = res;
    });
  }

  addToCollectionManagement(collectionId, jobId, collectionName) {
    const jobForm = this.jobs.find(x => x.job.id === jobId);

    this.addToCollectionManagementModel = {
      id: collectionId,
      name: '',
      description: '',
      jobId,
      mode: '',
      CollectionIdOld: ''
    };
    this.collectionService.addToCollectionName(this.addToCollectionManagementModel).subscribe(() => {
      this.messageService.add({ life: environment.messagePopupLifetimeMs, severity: 'success', detail: `<strong>${jobForm.job.jobName}</strong> has been added to <strong>${collectionName}</strong> collection successfully.` });
    });
  }

  removeFromCollectionManagement(collectionId, jobId, collectionName) {
    const jobForm = this.jobs.find(x => x.job.id === jobId);

    this.removeFromCollectionManagementModel = {
      id: collectionId,
      name: '',
      description: '',
      jobId,
      mode: '',
      CollectionIdOld: ''
    };

    this.confirmDialogService.show({
      message: `Are you sure you want to remove job <strong>${jobForm.job.jobName}</strong> from collection <strong>${collectionName}</strong>?`,
      header: 'Message',
      accept: () => {
        this.collectionService.removeFromCollectionName(this.removeFromCollectionManagementModel).subscribe(() => {
          this.getJobsByCollection(this.additionalParams);
          this.messageService.add(
            {
              severity: 'success',
              detail: `<strong>${jobForm.job.jobName}</strong> has been removed from <strong>${collectionName}</strong> collection successfully.`
            });
        });
      },
      reject: () => {

      }
    });
  }

  onShow() {
    this.collectionService.getAllCollections().subscribe(() => {
      this.collectionName = this.collections.find(x => x.id === this.collectionId).name;
      this.collectionEdit.controls['collectionName'].setValue(this.collectionName);
    });
  }

  private validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  changeJobOwner(jobId: string, jobOwner: string) {
    this.changeJobOwnerDialogComponent.open(jobId, jobOwner);
    this.changeJobOwnerDialogComponent.jobOwnerUpdate.subscribe(() => {
      this.refreshCollection();
    });
  }

  openEditWell(event, wellId: string) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.wellGroupValidationSub) {
      this.wellGroupValidationSub.unsubscribe();
    }

    this.wellGroupValidationSub = this.wellGroupValidatorService.validateWellGroupAccess(wellId)
      .subscribe(canProceed => {
        if (canProceed) {
          const editWellParameters = {
            wellId: wellId
          };
          this.applicationStateService.openWellEdit$.next(editWellParameters);
        }
      });
  }
}

export function checkReNameValidator(personalCollectionService: PersonalCollectionService, collectionId) {
  return (control: AbstractControl) => {

    const collectionCheckNameModel = {
      id: collectionId,
      name: control.value.trim(),
      description: '',
      jobId: '',
      mode: '',
      CollectionIdOld: ''
    };

    if (control.value && control.value.trim()) {
      return personalCollectionService.checkCollectionName(collectionCheckNameModel).pipe(
        map(res => {
          return (res === true) ? { unique: ValidatorSetting.ERROR_UNIQUE_COLLECTION_NAME } : null;
        })
      );
    }
    return of(null);
  };
}
